import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";
import config from "@/config";
import { AuthService } from "./auth";
import AbortAddon from "wretch/addons/abort";
import { isFeatureEnabled } from "@/utils/feature-flag";

export const DataService = {
    client: wretch(config.BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.BACKEND_URL], {
        credentials: "include",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .middlewares([
            next => async (url, opts) => {
                const validToken = await AuthService.getValidAccessToken();
                const { authenticated } = AuthService;
                if (!validToken) {
                    if (authenticated) window.location.reload();
                    else if (!window.location.pathname.startsWith("/connexion")) {
                        window.location.href = "/connexion/sso";
                    }
                }
                //@ts-ignore
                opts.headers.Authorization = `Bearer ${validToken}`;
                return next(url, opts);
            },
            next => async (url, opts) => {
                const userRaw = localStorage.getItem("current_user");
                if (userRaw) {
                    try {
                        const user = JSON.parse(userRaw);
                        //@ts-ignore
                        opts.headers["X-User-Id"] = user.id.toString();
                    } catch (error) {
                        console.error("Error parsing user from localStorage", error);
                    }
                }
                return next(url, opts);
            },
            next => (url, opts) => {
                if (isFeatureEnabled("disable-server-cache")) {
                    //@ts-ignore
                    opts.headers["Walter-Cache-Control"] = "nocache";
                }
                return next(url, opts);
            }
        ])
        .catcher(401, () => {
            const { authenticated } = AuthService;
            if (authenticated) window.location.reload();
            else if (!window.location.pathname.startsWith("/connexion")) {
                window.location.href = "/connexion/sso";
            }
        })
        .addon(AbortAddon())
        .addon(QueryStringAddon)
};
